import PublishActivityModal from './PublishActivityModal'
import { withPublishActivityModal } from './withPublishActivityModal'

const ConnectedPublishActivityModal =
  withPublishActivityModal(PublishActivityModal)

export { ConnectedPublishActivityModal as PublishActivityModal }
